import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState, PersonalizationFieldGroup } from '../types';
import { savePersonalizationFieldGroup } from '../util/personalizationFieldGroups';

function updatePersonalizationFieldGroupReducer(
  state: DesignState,
  action: PayloadAction<{ spreadIndex: number; group: PersonalizationFieldGroup }>,
) {
  const tree = state.designData?.spreads[action.payload.spreadIndex]?.conditionGroup;
  if (tree) {
    savePersonalizationFieldGroup(tree, action.payload.group);
  }
}

export default updatePersonalizationFieldGroupReducer;
